import { DragLayerMonitorProps } from "@minoru/react-dnd-treeview";
import { FC } from "react";
import { FileProperties } from "../../models/FileProperties";
import { TypeIcon } from "../DelayConfiguration/TypeIcon";

type Props = {
	monitorProps: DragLayerMonitorProps<FileProperties>;
};

export const CustomDragPreview: FC<Props> = (props) => {
	const item = props.monitorProps.item;

	return (
		<div
			style={{
				alignItems: "center",
				backgroundColor: "#1967d2",
				borderRadius: "4px",
				boxShadow:
					" 0 12px 24px -6px rgba(0, 0, 0, .25); 0 0 0 1px rgba(0, 0, 0, .08)",
				color: "#fff",
				display: "inline-grid",
				fontSize: "0.75rem",
				gap: "8px",
				gridTemplateColumns: "auto auto",
				padding: "4px 8px",
				pointerEvents: "none",
			}}
		>
			<div
				style={{
					alignItems: "center",
					display: "flex",
				}}
			>
				<TypeIcon droppable={item.droppable!} fileType={item?.data?.fileType} />
			</div>
			<div
				style={{
					alignItems: "center",
					display: "flex",
				}}
			>
				{item.text}
			</div>
		</div>
	);
};
